const handlePrint = (data, copy = 1) => {
  const dtSubTotal = (data.dtPrice || 0) * (data.dtQty || 0);
  const fcSubTotal = (data.fcPrice || 0) * (data.fcQty || 0);
  const blSubTotal = (data.blPrice || 0) * (data.blQty || 0);
  const total =
    (data.ws || 0) +
    (data.dr || 0) +
    (data.fd || 0) +
    dtSubTotal +
    fcSubTotal +
    blSubTotal +
    (data.sp || 0) +
    (data.ad || 0) +
    (data.sw || 0);

  const change = data.cs - total;

  const lineLength = 26;
  const center1 = centerText(process.env.REACT_APP_TITLE, lineLength);
  const center2 = centerText(data.br?.nm, lineLength);
  const center3 = centerText("Sales Invoice", lineLength);
  const center4 = centerText(
    new Date(data.createdAt).toLocaleString(),
    lineLength
  );
  const center5 = centerText(`TRAN#:${data.tx}`, lineLength);
  const center6 = centerText("==========================", lineLength);

  const justify1 = justifyText(
    [
      ["Name:", data.nm],
      ["Weight(kg):", data.wt.toFixed(2)],
      ...(data.ws ? [["Wash:", data.ws.toFixed(2)]] : []),
      ...(data.sw ? [["Super Wash:", data.sw.toFixed(2)]] : []),
      ...(data.sp ? [["Spin:", data.sp.toFixed(2)]] : []),
      ...(data.dr ? [["Dry:", data.dr.toFixed(2)]] : []),
      ...(data.ad ? [["Add Dry:", data.ad.toFixed(2)]] : []),
      ...(data.fd ? [["Fold:", data.fd.toFixed(2)]] : []),
      ...(dtSubTotal ? [["Detergent:", dtSubTotal.toFixed(2)]] : []),
      ...(fcSubTotal ? [["Fabcon:", fcSubTotal.toFixed(2)]] : []),
      ...(blSubTotal ? [["Bleach:", blSubTotal.toFixed(2)]] : []),
    ],
    lineLength
  );

  const center7 = centerText("==========================", lineLength);

  const justify2 = justifyText(
    [
      ["Total:", total.toFixed(2)],
      ...(!!data.isUnpaid
        ? [["", "Unpaid"]]
        : data.cs > 0
          ? [["Cash:", data.cs.toFixed(2)]]
          : [["", "Late Payment"]]),
      ...(change > 0
        ? [["Change:", change.toFixed(2)]]
        : []),
      ["Signature:", data.usr?.fullname],
    ],
    lineLength
  );

  const receipt1 = `${center1}\n${center2}\n${center3}\n${center4}\n${center5}\n${center6}\n`;
  const receipt2 = `${justify1}\n`;
  const receipt3 = `${center7}\n${justify2}\n\n\n\n`;

  print(receipt1, receipt2, receipt3, copy);
};

const print = async (receipt1, receipt2, receipt3, copy) => {
  try {
    const characteristic = await connectToPrinter();

    const encoder1 = new TextEncoder();
    const data1 = encoder1.encode(receipt1);

    const encoder2 = new TextEncoder();
    const data2 = encoder2.encode(receipt2);

    const encoder3 = new TextEncoder();
    const data3 = encoder3.encode(receipt3);

    await characteristic.writeValue(data1);
    await characteristic.writeValue(data2);
    await characteristic.writeValue(data3);
    if (copy === 2) {
      await characteristic.writeValue(data1);
      await characteristic.writeValue(data2);
      await characteristic.writeValue(data3);
    }
    console.log("Data sent to the printer!");
  } catch (error) {
    console.error("Error connecting to printer:", error);
  }
};

const connectToPrinter = async () => {
  const primaryPrinter = {
    primaryService: "49535343-fe7d-4ae5-8fa9-9fafd205e455",
    characteristic: "49535343-8841-43f4-a8d4-ecbe34729bb3",
  };

  try {
    console.log("Connecting to printer...");

    const device = await navigator.bluetooth.requestDevice({
      filters: [
        { namePrefix: "JP-58B" },
        { namePrefix: "POS58D" },
        { namePrefix: "XP-58H" },
        { namePrefix: "XP" },
      ],
      optionalServices: [
        primaryPrinter.primaryService,
      ],
    });

    console.log("Selected device:", device.name);

    const server = await device.gatt.connect();

    try {
      const service = await server.getPrimaryService(
        primaryPrinter.primaryService
      );

      const characteristic =
        await service.getCharacteristic(
          primaryPrinter.characteristic
        );

      console.log("Connected via JP printer service");
      return characteristic;
    } catch {
      console.log(
        "Known JP service not found. Scanning services..."
      );
    }

    // Fallback - auto discover writable characteristic
    const services = await server.getPrimaryServices();

    for (const service of services) {
      console.log(`Service UUID: ${service.uuid}`);

      const characteristics =
        await service.getCharacteristics();

      for (const characteristic of characteristics) {
        console.log(
          `Characteristic UUID: ${characteristic.uuid}`
        );

        console.log(
          "Supports write:",
          characteristic.properties.write
        );

        console.log(
          "Supports writeWithoutResponse:",
          characteristic.properties.writeWithoutResponse
        );

        if (
          characteristic.properties.write ||
          characteristic.properties.writeWithoutResponse
        ) {
          console.log(
            "Connected using discovered writable characteristic"
          );

          return characteristic;
        }
      }
    }

    throw new Error(
      "No writable characteristic found."
    );
  } catch (error) {
    console.error(
      "Error connecting to printer:",
      error
    );

    alert(
      "Can't connect to the printer. Please try reprinting or contact the admin."
    );

    return null;
  }
};

// Helper function to center text
const centerText = (text, lineLength) => {
  const spaces = Math.floor((lineLength - text.length) / 2);
  return " ".repeat(spaces) + text;
};

// Helper function for justification
const justifyText = (items, lineLength) => {
  let result = "";
  items.forEach(([left, right]) => {
    if (left.length + right.length > lineLength) {
      // If the left text is too long, move it to the next line
      const wrappedLeft = wrapText(left, lineLength);
      const spaces = Math.max(
        0,
        lineLength - wrappedLeft[0].length - right.length
      ); // Adjust spaces for first line
      result += wrappedLeft[0] + " ".repeat(spaces) + right + "\n"; // First line with right content

      // Add remaining lines of the left text
      for (let i = 1; i < wrappedLeft.length; i++) {
        result += wrappedLeft[i] + "\n";
      }
    } else {
      // Standard justify
      const spaces = Math.max(0, lineLength - left.length - right.length);
      result += left + " ".repeat(spaces) + right + "\n";
    }
  });
  return result;
};

// Helper function to wrap text
const wrapText = (text, lineLength) => {
  const lines = [];
  while (text.length > lineLength) {
    lines.push(text.slice(0, lineLength)); // Take the first `lineLength` characters
    text = text.slice(lineLength); // Remove the processed characters
  }
  lines.push(text); // Add any remaining text
  return lines;
};

export default handlePrint;
